var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlusCircleWhite24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5E369412-AB03-442A-84C7-FDE7F9F96A9F_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kaardid",
    transform: "translate(-1065.000000, -100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(1065.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Plus-Circle_White-24px"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8 L12,16",
    id: "Path-2",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,12 L16,12",
    id: "Path-2",
    stroke: "#000000",
    strokeWidth: 2
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusCircleWhite24Px);
export default __webpack_public_path__ + "static/media/Icon_Plus-Circle_White-24px.fe1743e64fc1b31fff5253f4a0fa5b6b.svg";
export { ForwardRef as ReactComponent };